
import React from 'react';

const ReportHeader: React.FC = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight">Compliance Reports</h1>
      <p className="text-muted-foreground">
        Manage and monitor regulatory reporting requirements
      </p>
    </div>
  );
};

export default ReportHeader;
